export default __webpack_public_path__ + "static/media/left-purple.deab4226.svg";